import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { ContactTypeModel } from '@models/billingNote'
import type { AppDispatch } from '@redux/store'
import type {
  Action, ActionResult, EntityOptions, Errors,
} from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/contactType/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/contactType/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/contactType/FETCH_FAILURE'

export type ContactTypeModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
}

const initialState: ContactTypeModuleState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(): Action {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(): Action {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []): Action {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadContactTypes(options: EntityOptions = {}) {
  return (dispatch: AppDispatch): Promise<ActionResult<ContactTypeModel[]>> => {
    dispatch(fetchRequest())

    const promise = api('/contact-types', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.CONTACT_TYPE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: ContactTypeModuleState = initialState,
  action: Action = { type: '' },
): ContactTypeModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
